import React, { FC, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';

import { ROLE_TYPES } from '../../utils/DataConstants';
import { BUYER_ONLY_NO_STORE_ASSOCIATE } from '../roles/roles';
import { isSupplierPayingCustomer } from '../../utils/DataAccessUtils';
import { Button } from 'antd';
import { getLinkWIthBackLinkParams } from '../../utils/HistoryUtils';

const WorkOrderCreateButton: FC<any> = ({
	currentUser,
	userType,
	location,
	backText,
	getLink,
	size = 'large',
	type = 'primary',
	title,
}): React.ReactElement => {
	const BACK_TEXT = useMemo(() => backText || 'Back to Work Orders', [backText]);

	const getTitle = useCallback(() => {
		if (title) {
			return title;
		}
		if (userType === ROLE_TYPES.SUPPLIER) {
			return (
				<span>
					Create<span className="inline-block-visible-xl">&nbsp;Work Order</span>
				</span>
			);
		}
		if (
			currentUser.roles &&
			currentUser.roles.some((role) => BUYER_ONLY_NO_STORE_ASSOCIATE.has(role))
		) {
			return (
				<span>
					Create<span className="inline-block-visible-xl">&nbsp;Work Order</span>
				</span>
			);
		}
		return (
			<span>
				Request<span className="inline-block-visible-xl">&nbsp;Service</span>
			</span>
		);
	}, [currentUser.roles, title, userType]);

	const getFinalLink = useCallback(
		(path) =>
			getLink
				? getLink(location, BACK_TEXT, path)
				: getLinkWIthBackLinkParams(location, BACK_TEXT, path),
		[location, BACK_TEXT, getLink]
	);

	const buyerCreateButton = useMemo(
		() =>
			currentUser.roles &&
			currentUser.roles.some((role) => BUYER_ONLY_NO_STORE_ASSOCIATE.has(role)) ? (
				<Link to={getFinalLink('/buyer/workOrders/newWorkOrder')}>
					<Button type={type} size={size}>
						{getTitle()}
					</Button>
				</Link>
			) : (
				<Link to={getFinalLink('/buyer/workOrders/requestService')}>
					<Button type={type} size={size}>
						{getTitle()}
					</Button>
				</Link>
			),
		[currentUser, getFinalLink, getTitle, size, type]
	);

	const supplierCreateButton = useMemo(
		() => (
			<Link
				to={
					isSupplierPayingCustomer(currentUser)
						? getFinalLink('/supplier/workOrders/newContractorWorkOrder')
						: getFinalLink('/supplier/workOrders/newWorkOrder')
				}
			>
				<Button type={type} size={size}>
					{getTitle()}
				</Button>
			</Link>
		),
		[currentUser, getFinalLink, getTitle, size, type]
	);

	return userType === ROLE_TYPES.SUPPLIER ? supplierCreateButton : buyerCreateButton;
};

const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,
	location: ownProps.location,
});

const WOCreateButton = withRouter(connect(mapStateToProps)(WorkOrderCreateButton));

export default connect(
	(state) => ({
		userType: (state as unknown as any).session.userType,
	}),
	() => ({})
)(WOCreateButton);
